import React from 'react';
import { Drawer, Button, Col, Row, Input, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

class DrawerPosnet extends React.Component {
  state = { visible: false, childrenDrawer: false };

  onClose = () => {
    this.props.ocultarDrawer();
  };

  onSubmitSinStock = () => {
    let numeroTicket = this.props.form.getFieldValue('numeroTicket');
    if (numeroTicket && numeroTicket.length > 0 && this.props.codigo) {
      this.props.onFinalizarSinStock(numeroTicket, this.props.codigo);
    } else {
      if (!numeroTicket || numeroTicket.length < 1) {
        notification.error({
          message: 'ERROR REFERENTE AL NUMERO DE TICKET.',
          description: ' VERIFIQUE QUE ESTE EXISTA Y ESTE BIEN CARGADO.',
        });
      } else {
        notification.error({
          message: 'ERROR.',
          description: 'ERROR CON EL PROCESAMIENTO DEL CODIGO DE OPERACION.',
        });
      }
    }
  };

  showChildrenDrawer = () => {
    this.setState({
      childrenDrawer: true,
    });
  };

  onChildrenDrawerClose = () => {
    this.setState({
      childrenDrawer: false,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Drawer
          title="Datos del Posnet"
          width={420}
          onClose={this.onClose}
          visible={this.props.visible}
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={12}>
                <h4>Codigo de Operacion: </h4>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <h3>{this.props.codigo ? this.props.codigo : 'SIN DATOS'}</h3>
              </Col>
              <Col span={12}>
                <Button
                  type="primary"
                  disabled={this.props.codigo}
                  onClick={this.props.generarCodigoOperacion}
                >
                  Generar Codigo
                </Button>
              </Col>
            </Row>
            <br />
            <Row gutter={16}>
              <Col span={20}>
                <Form.Item label="Numero de Ticket">
                  {getFieldDecorator('numeroTicket', {
                    rules: [
                      {
                        required: true,
                        message: 'Ingrese el numero de Ticket',
                      },
                    ],
                  })(
                    <Input
                      onPressEnter={this.onSubmitSinStock}
                      placeholder="Por favor, ingresar el numero de ticket"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div
            style={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
            }}
          >
            <Button onClick={this.onClose} style={{ marginRight: 8 }}>
              Cancelar
            </Button>
            <Button
              onClick={this.onSubmitSinStock}
              disabled={!this.props.crearVentaCompleta}
              type="primary"
              style={{ marginTop: 10, marginLeft: 5 }}
            >
              <Icons.CreditCardOutlined />
              Generar Venta
            </Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default Form.create()(DrawerPosnet);
